import { NgClass } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { ChangeDetectorRef, Component, HostListener, OnInit } from '@angular/core';
import { ToggleService } from '../sidebar/toggle.service';
import { MatButtonModule } from '@angular/material/button';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { CustomizerSettingsService } from '../../customizer-settings/customizer-settings.service';

@Component({
    selector: 'app-header',
    imports: [NgClass, MatMenuModule, MatButtonModule, RouterLink],
    templateUrl: './header.component.html',
    styleUrl: './header.component.scss'
})
export class HeaderComponent implements OnInit {
    user: any;

    // isSidebarToggled
    isSidebarToggled = false;

    // isToggled
    isToggled = false;

    constructor(
        private router: Router,
        private toggleService: ToggleService,
        public themeService: CustomizerSettingsService,
        private cdr: ChangeDetectorRef
    ) {
        this.toggleService.isSidebarToggled$.subscribe(isSidebarToggled => {
            this.isSidebarToggled = isSidebarToggled;
        });
        this.themeService.isToggled$.subscribe(isToggled => {
            this.isToggled = isToggled;
        });
    }

    ngOnInit() {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                // if (this.router.url.includes('/dashboard') || this.router.url.includes('Departments/ProductionShiftReportCore') || this.router.url.includes('Departments/ProductionShiftReports') || this.router.url.includes('Departments/ProductionShiftsFinancialReportViewer') || this.router.url.includes('Departments/ProductionShiftReportDelays') || this.router.url.includes('Departments/ProductionShiftViewer') || this.router.url.includes('Ticketing/CreateProblemsAndIssues') || this.router.url.includes('Ticketing/AllTickets') || this.router.url.includes('Ticketing/AllTickets/Attachments/') || this.router.url.includes('Ticketing/AllTickets/Notes/') || this.router.url.includes('Ticketing/AllTickets/Thread/') || this.router.url.includes('Ticketing/TicketingReport') || this.router.url.includes('Ticketing/Dashboard') || this.router.url.includes('my-profile') || this.router.url.includes('Departments/TicketSubmissionInit') || this.router.url.includes('Departments/StockTakeData') || this.router.url.includes('Departments/StockTakeReconData') || this.router.url.includes('Departments/AllocatedStockItems') || this.router.url.includes('Departments/OpenSalesOrders') || this.router.url.includes('Departments/HR')) {
                if (!this.router.url.includes('/authentication')) {
                    this.user = localStorage.getItem('user');
                    this.user = (JSON.parse(this.user))?.user_info;
                    if (!localStorage.getItem('token')) {
                        localStorage.clear();
                        this.router.navigate([''])
                    }
                }
            }
        });
    }

    // Burger Menu Toggle
    toggle() {
        this.toggleService.toggle();
    }

    // Header Sticky
    isSticky: boolean = false;
    @HostListener('window:scroll', ['$event'])
    checkScroll() {
        const scrollPosition = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
        if (scrollPosition >= 50) {
            this.isSticky = true;
        } else {
            this.isSticky = false;
        }
    }

    // Dark Mode
    toggleTheme() {
        this.themeService.toggleTheme();
    }

    // Sidebar Dark
    toggleSidebarTheme() {
        this.themeService.toggleSidebarTheme();
    }

    // Right Sidebar
    toggleRightSidebarTheme() {
        this.themeService.toggleRightSidebarTheme();
    }

    // Hide Sidebar
    toggleHideSidebarTheme() {
        this.themeService.toggleHideSidebarTheme();
    }

    // Header Dark Mode
    toggleHeaderTheme() {
        this.themeService.toggleHeaderTheme();
    }

    // Card Border
    toggleCardBorderTheme() {
        this.themeService.toggleCardBorderTheme();
    }

    // RTL Mode
    toggleRTLEnabledTheme() {
        this.themeService.toggleRTLEnabledTheme();
    }

    logout() {
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        const rememberMe = localStorage.getItem('rememberMe') === 'true';
        if (!rememberMe) {
            localStorage.removeItem('refresh_token');
            localStorage.removeItem('refresh_token_issued_at');
            localStorage.removeItem('rememberMe');
        }
        localStorage.clear();
        this.router.navigate(['/authentication/logout'])
    }

    refresh() {
        window.location.reload();
    }
}